import { css } from 'styled-components';
import brand from './brand';
export default css `
  /* @note: This is an attempt to use default scrollbars on touch devices */
  @media (hover: hover) or (pointer: fine) {
    &::-webkit-scrollbar-track {
      background-color: ${brand.grey};
    }

    &::-webkit-scrollbar {
      background-color: ${brand.grey};
      height: 6px;
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${brand.yellow};
      border-radius: 0;
      cursor: pointer;
    }
  }
`;
